import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <div className="container">
      <SEO
        title="Página no encontrada — Mi Lugar CET y Centro de Día"
        description="La página que buscás no existe o fue movida. Volvé al inicio o contactanos para ayudarte."
        path="/404"
        noindex
      />

      <div className="sede-header" style={{ textAlign: 'center', padding: '60px 20px' }}>
        <h1>404 — Página no encontrada</h1>
        <p>La página que estás buscando no existe o fue movida. Te invitamos a volver al inicio o ponerte en contacto con nosotros.</p>
      </div>

      <div className="cta-buttons" style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap', marginBottom: '60px' }}>
        <Link to="/" className="btn">Volver al inicio</Link>
        <Link to="/contacto" className="btn btn-secondary">Contactanos</Link>
      </div>
    </div>
  );
};

export default NotFound;
